var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"settings"}},[_c('f7-navbar',{attrs:{"title":"Settings","back-link":"Back"}}),_vm._v(" "),_c('f7-block-title',[_vm._v("Settings")]),_vm._v(" "),_c('f7-button',{on:{"click":_vm.forceSWupdate}},[_vm._v("Check For Updates")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }